import React from "react";

import styles from "./Clearfix.module.scss";

export default function Clearfix() {
  return <div className={styles.clearfix} />;
}
